import { GalleryCarouselDialog } from './GalleryCarouselDialog';

export { GalleryCarouselDialog };
export default GalleryCarouselDialog;
